<template>
    <div class="terms">
        <vue-headful :title="$t('terms.meta-title')" :keywords="$t('terms.meta-keywords')" :description="$t('terms.meta-description')"/>

        <!-- <section class="hero is-terms">
            <div class="hero-body">
                <div class="container has-text-centered">
                    <transition name="slide-down">
                        <h1 class="title is-size-3 is-unselectable is-spaced">{{ $t('terms.title') }}</h1>
                    </transition>
                    <transition name="slide-up-200ms">
                        <h2 class="subtitle is-unselectable" v-html="$t('terms.subtitle')"/>
                    </transition>
                </div>
            </div>
        </section> -->

        <section class="section">
            <div class="container">
                <h4 class="title is-4 is-spaced" id="privacy">
                    <a class="is-anchor-link" href="#privacy">#</a>
                    <span>{{ $t('terms.privacy.title') }}</span>
                </h4>

                <div class="content has-padding-left">
                    <p class="">
                        <span>{{ $t('terms.privacy.update-time') }}</span>
                    </p>
                    <p class="">
                        <span>{{ $t('terms.privacy.effective-time') }}</span>
                    </p>
                    <p class="">
                        <span>{{ $t('terms.privacy.preamble1-1') }}</span>
                        <span>{{ $t('terms.privacy.preamble1-2') }}</span>
                        <span>{{ $t('terms.privacy.preamble1-3') }}</span>
                        <span>{{ $t('terms.privacy.preamble1-4') }}</span>
                    </p>
                    <p class="">
                        <span><b>{{ $t('terms.privacy.preamble1-5') }}</b></span>
                    </p>

                    <p class="">
                        <span>{{ $t('terms.privacy.catalog.title') }}</span>
                    </p>
                    <p class="has-left-margin">
                        <a class="is-anchor-link" href="#collect-use-info">{{ $t('terms.privacy.collect-use.title') }}</a> <br>
                        <a class="is-anchor-link" href="#cookie">{{ $t('terms.privacy.cookie.title') }}</a> <br>
                        <a class="is-anchor-link" href="#share-transfer-disclose-info">{{ $t('terms.privacy.share.title') }}</a> <br>
                        <a class="is-anchor-link" href="#protect-info">{{ $t('terms.privacy.protect.title') }}</a> <br>
                        <a class="is-anchor-link" href="#global-transfer-info">{{ $t('terms.privacy.global.title') }}</a> <br>
                        <a class="is-anchor-link" href="#minors-protection">{{ $t('terms.privacy.minors.title') }}</a> <br>
                        <a class="is-anchor-link" href="#how-update">{{ $t('terms.privacy.how-update.title') }}</a> <br>
                        <a class="is-anchor-link" href="#contact">{{ $t('terms.privacy.contact.title') }}</a> 
                    </p>

                    <h5 id="collect-use-info">
                        <a class="is-anchor-link" href="#collect-use-info">#</a>
                        <span>{{ $t('terms.privacy.collect-use.title') }}</span>
                    </h5>
                    <p class="">
                        <span>{{ $t('terms.privacy.collect-use.personal-info') }}</span>
                    </p>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.privacy.collect-use.intro1-1') }}</span>
                        <span>{{ $t('terms.privacy.collect-use.intro1-2') }}</span>
                        <span>{{ $t('terms.privacy.collect-use.intro1-3') }}</span>
                        <span>{{ $t('terms.privacy.collect-use.intro1-4') }}</span>
                        <span>{{ $t('terms.privacy.collect-use.intro1-5') }}</span>
                        <span>{{ $t('terms.privacy.collect-use.intro1-6') }}</span>
                        <span>{{ $t('terms.privacy.collect-use.intro1-7') }}</span>
                    </p>
                    <p class="">
                        <span>{{ $t('terms.privacy.collect-use.info') }}</span>
                    </p>
                    <p class="has-left-margin">
                        <span>{{ $t('terms.privacy.collect-use.info1') }}</span> <br>
                        <span>{{ $t('terms.privacy.collect-use.info2') }}</span>
                    </p>

                    <p class="">
                        <span>{{ $t('terms.privacy.collect-use.use') }}</span>
                    </p>
                    <p class="has-left-margin">
                        <span>{{ $t('terms.privacy.collect-use.use1') }}</span> <br>
                        <span>{{ $t('terms.privacy.collect-use.use2') }}</span>
                    </p>
                    <p class="">
                        <span>{{ $t('terms.privacy.collect-use.exclude') }}</span>
                    </p>
                    <p class="has-left-margin">
                        <span>{{ $t('terms.privacy.collect-use.exclude1') }}</span> <br>
                        <span>{{ $t('terms.privacy.collect-use.exclude2') }}</span> <br>
                        <span>{{ $t('terms.privacy.collect-use.exclude3') }}</span> <br>
                        <span>{{ $t('terms.privacy.collect-use.exclude4') }}</span> <br>
                        <span>{{ $t('terms.privacy.collect-use.exclude5') }}</span> <br>
                        <span>{{ $t('terms.privacy.collect-use.exclude6') }}</span>
                    </p>

                    <h5 id="cookie">
                        <a class="is-anchor-link" href="#cookie">#</a>
                        <span>{{ $t('terms.privacy.cookie.title') }}</span>
                    </h5>
                    <p class="">
                        <span>{{ $t('terms.privacy.cookie.intro') }}</span>
                    </p>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.privacy.cookie.intro1-1') }}</span>
                        <span>{{ $t('terms.privacy.cookie.intro1-2') }}</span>
                        <span>{{ $t('terms.privacy.cookie.intro1-3') }}</span>
                        <span>{{ $t('terms.privacy.cookie.intro1-4') }}</span>
                    </p>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.privacy.cookie.intro2-1') }}</span>
                        <span>{{ $t('terms.privacy.cookie.intro2-2') }}</span>
                        <span>{{ $t('terms.privacy.cookie.intro2-3') }}</span>
                    </p>

                    <h5 id="share-transfer-disclose-info">
                        <a class="is-anchor-link" href="#share-transfer-disclose-info">#</a>
                        <span>{{ $t('terms.privacy.share.title') }}</span>
                    </h5>
                    <p class="">
                        <span><b>{{ $t('terms.privacy.share.share') }}</b></span>
                    </p>
                    <p class="">
                        <span>{{ $t('terms.privacy.share.share-desc') }}</span>
                    </p>
                    <p class="has-left-margin">
                        <span>{{ $t('terms.privacy.share.share-desc1') }}</span> <br>
                        <span>{{ $t('terms.privacy.share.share-desc2') }}</span> <br>
                        <span>{{ $t('terms.privacy.share.share-desc3-1') }}</span>
                        <span>{{ $t('terms.privacy.share.share-desc3-2') }}</span>
                        <span>{{ $t('terms.privacy.share.share-desc3-3') }}</span> 
                    </p>

                    <p class="">
                        <span><b>{{ $t('terms.privacy.share.transfer') }}</b></span>
                    </p>
                    <p class="">
                        <span>{{ $t('terms.privacy.share.transfer-desc') }}</span>
                    </p>
                    <p class="has-left-margin">
                        <span>{{ $t('terms.privacy.share.transfer-desc1') }}</span> <br>
                        <span>{{ $t('terms.privacy.share.transfer-desc2') }}</span> <br>
                        <span>{{ $t('terms.privacy.share.transfer-desc3') }}</span> <br>
                        <span>{{ $t('terms.privacy.share.transfer-desc4-1') }}</span>
                        <span>{{ $t('terms.privacy.share.transfer-desc4-2') }}</span>
                        <span>{{ $t('terms.privacy.share.transfer-desc4-3') }}</span> 
                    </p>

                    <p class="">
                        <span><b>{{ $t('terms.privacy.share.public') }}</b></span>
                    </p>
                    <p class="">
                        <span>{{ $t('terms.privacy.share.public-desc') }}</span>
                    </p>
                    <p class="has-left-margin">
                        <span>{{ $t('terms.privacy.share.public-desc1') }}</span> <br>
                        <span>{{ $t('terms.privacy.share.public-desc2') }}</span> <br>
                        <span>{{ $t('terms.privacy.share.public-desc3') }}</span>
                    </p>

                    <h5 id="protect-info">
                        <a class="is-anchor-link" href="#protect-info">#</a>
                        <span>{{ $t('terms.privacy.protect.title') }}</span>
                    </h5>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.privacy.protect.intro1-1') }}</span>
                        <span>{{ $t('terms.privacy.protect.intro1-2') }}</span>
                        <span>{{ $t('terms.privacy.protect.intro1-3') }}</span>
                        <span>{{ $t('terms.privacy.protect.intro1-4') }}</span>
                        <span>{{ $t('terms.privacy.protect.intro1-5') }}</span>
                    </p>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.privacy.protect.intro2-1') }}</span>
                        <span>{{ $t('terms.privacy.protect.intro2-2') }}</span>
                        <span>{{ $t('terms.privacy.protect.intro2-3') }}</span>
                        <span>{{ $t('terms.privacy.protect.intro2-4') }}</span>
                    </p>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.privacy.protect.intro3-1') }}</span>
                        <span>{{ $t('terms.privacy.protect.intro3-2') }}</span>
                    </p>

                    <h5 id="global-transfer-info">
                        <a class="is-anchor-link" href="#global-transfer-info">#</a>
                        <span>{{ $t('terms.privacy.global.title') }}</span>
                    </h5>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.privacy.global.intro1-1') }}</span>
                        <span>{{ $t('terms.privacy.global.intro1-2') }}</span>
                        <span>{{ $t('terms.privacy.global.intro1-3') }}</span>
                    </p>

                    <h5 id="minors-protection">
                        <a class="is-anchor-link" href="#minors-protection">#</a>
                        <span>{{ $t('terms.privacy.minors.title') }}</span>
                    </h5>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.privacy.minors.intro1-1') }}</span>
                        <span>{{ $t('terms.privacy.minors.intro1-2') }}</span>
                        <span>{{ $t('terms.privacy.minors.intro1-3') }}</span>
                        <span>{{ $t('terms.privacy.minors.intro1-4') }}</span>
                        <span>{{ $t('terms.privacy.minors.intro1-5') }}</span>
                    </p>

                    <h5 id="how-update">
                        <a class="is-anchor-link" href="#how-update">#</a>
                        <span>{{ $t('terms.privacy.how-update.title') }}</span>
                    </h5>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.privacy.how-update.intro1-1') }}</span>
                        <span>{{ $t('terms.privacy.how-update.intro1-2') }}</span>
                        <span>{{ $t('terms.privacy.how-update.intro1-3') }}</span>
                        <span>{{ $t('terms.privacy.how-update.intro1-4') }}</span>
                        <span>{{ $t('terms.privacy.how-update.intro1-5') }}</span>
                    </p>

                    <h5 id="contact">
                        <a class="is-anchor-link" href="#contact">#</a>
                        <span>{{ $t('terms.privacy.contact.title') }}</span>
                    </h5>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.privacy.contact.intro1') }}</span>
                    </p>
                </div>

                <hr>

                <h4 id="agreement" class="title is-4 is-spaced">
                    <a class="is-anchor-link" href="#agreement">#</a>
                    <span>{{ $t('terms.terms.title') }}</span>
                </h4>

                <div class="content has-padding-left">
                    <p class="">
                        <span>{{ $t('terms.terms.update-time') }}</span>
                    </p>
                    <p class="">
                        <span>{{ $t('terms.terms.effective-time') }}</span>
                    </p>

                    <p class="">
                        <span>{{ $t('terms.terms.catalog.title') }}</span>
                    </p>
                    <p class="has-left-margin">
                        <a class="is-anchor-link" href="#agreement">{{ $t('terms.terms.agree.title') }}</a> <br>
                        <a class="is-anchor-link" href="#for-personal">{{ $t('terms.terms.for-personal.title') }}</a> <br>
                        <a class="is-anchor-link" href="#intellectual">{{ $t('terms.terms.intellectual.title') }}</a> <br>
                        <a class="is-anchor-link" href="#terms-privacy">{{ $t('terms.terms.privacy.title') }}</a> <br>
                        <a class="is-anchor-link" href="#service-change">{{ $t('terms.terms.modify.title') }}</a> <br>
                        <a class="is-anchor-link" href="#liability-limitation">{{ $t('terms.terms.limit.title') }}</a> <br>
                        <a class="is-anchor-link" href="#terms-protect">{{ $t('terms.terms.protect.title') }}</a> <br>
                        <a class="is-anchor-link" href="#law">{{ $t('terms.terms.law.title') }}</a>
                    </p>

                    <h5 id="agreement">
                        <a class="is-anchor-link" href="#agreement">#</a>
                        <span>{{ $t('terms.terms.agree.title') }}</span>
                    </h5>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.terms.agree.intro') }}</span>
                    </p>

                    <h5 id="for-personal">
                        <a class="is-anchor-link" href="#for-personal">#</a>
                        <span>{{ $t('terms.terms.for-personal.title') }}</span>
                    </h5>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.terms.for-personal.intro1-1') }}</span>
                        <span>{{ $t('terms.terms.for-personal.intro1-2') }}</span>
                        <span>{{ $t('terms.terms.for-personal.intro1-3') }}</span>
                    </p>

                    <h5 id="intellectual">
                        <a class="is-anchor-link" href="#intellectual">#</a>
                        <span>{{ $t('terms.terms.intellectual.title') }}</span>
                    </h5>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.terms.intellectual.intro1-1') }}</span>
                        <span>{{ $t('terms.terms.intellectual.intro1-2') }}</span>
                        <span>{{ $t('terms.terms.intellectual.intro1-3') }}</span>
                        <span>{{ $t('terms.terms.intellectual.intro1-4') }}</span>
                    </p>
                    
                    <h5 id="terms-privacy">
                        <a class="is-anchor-link" href="#terms-privacy">#</a>
                        <span>{{ $t('terms.terms.privacy.title') }}</span>
                    </h5>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.terms.privacy.intro1-1') }}</span>
                        <span>{{ $t('terms.terms.privacy.intro1-2') }}</span>
                        <span>{{ $t('terms.terms.privacy.intro1-3') }}</span>
                    </p>
                    <p class="has-left-margin">
                        <span>{{ $t('terms.terms.privacy.intro2-1') }}</span> <br>
                        <span>{{ $t('terms.terms.privacy.intro2-2') }}</span> <br>
                        <span>{{ $t('terms.terms.privacy.intro2-3') }}</span> <br>
                        <span>{{ $t('terms.terms.privacy.intro2-4') }}</span> <br>
                        <span>{{ $t('terms.terms.privacy.intro2-5') }}</span> <br>
                    </p>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.terms.privacy.intro3-1') }}</span>
                        <a href="#privacy">{{ $t('terms.terms.privacy.intro3-2') }}</a>
                        <span>{{ $t('terms.terms.privacy.intro3-3') }}</span>
                        <span>{{ $t('terms.terms.privacy.intro3-4') }}</span>
                    </p>

                    <h5 id="service-change">
                        <a class="is-anchor-link" href="#service-change">#</a>
                        <span>{{ $t('terms.terms.modify.title') }}</span>
                    </h5>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.terms.modify.intro1-1') }}</span>
                        <span>{{ $t('terms.terms.modify.intro1-2') }}</span>
                    </p>

                    <h5 id="liability-limitation">
                        <a class="is-anchor-link" href="#liability-limitation">#</a>
                        <span>{{ $t('terms.terms.limit.title') }}</span>
                    </h5>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.terms.limit.intro1-1') }}</span>
                        <span>{{ $t('terms.terms.limit.intro1-2') }}</span>
                        <span>{{ $t('terms.terms.limit.intro1-3') }}</span>
                        <span>{{ $t('terms.terms.limit.intro1-4') }}</span>
                    </p>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.terms.limit.intro2') }}</span>
                    </p>
                    <p class="has-left-margin2">
                        <span>{{ $t('terms.terms.limit.intro2-1') }}</span> <br>
                        <span>{{ $t('terms.terms.limit.intro2-2') }}</span> <br>
                        <span>{{ $t('terms.terms.limit.intro2-3') }}</span> <br>
                        <span>{{ $t('terms.terms.limit.intro2-4') }}</span>
                    </p>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.terms.limit.intro3-1') }}</span>
                        <span>{{ $t('terms.terms.limit.intro3-2') }}</span>
                        <span>{{ $t('terms.terms.limit.intro3-3') }}</span>
                        <span>{{ $t('terms.terms.limit.intro3-4') }}</span>
                        <span>{{ $t('terms.terms.limit.intro3-5') }}</span>
                        <span>{{ $t('terms.terms.limit.intro3-6') }}</span>
                        <span>{{ $t('terms.terms.limit.intro3-7') }}</span>
                    </p>

                    <h5 id="terms-protect">
                        <a class="is-anchor-link" href="#terms-protect">#</a>
                        <span>{{ $t('terms.terms.protect.title') }}</span>
                    </h5>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.terms.protect.intro1-1') }}</span>
                        <span>{{ $t('terms.terms.protect.intro1-2') }}</span>
                    </p>

                    <h5 id="law">
                        <a class="is-anchor-link" href="#law">#</a>
                        <span>{{ $t('terms.terms.law.title') }}</span>
                    </h5>
                    <p class="has-text-identation">
                        <span>{{ $t('terms.terms.law.intro1-1') }}</span>
                        <span>{{ $t('terms.terms.law.intro1-2') }}</span>
                        <span>{{ $t('terms.terms.law.intro1-3') }}</span>
                    </p>
                   
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default { }
</script>

<style lang="scss" scoped>
    @import "@/mixins/colors.scss";
    //Background of the hero panel.
    .hero.is-terms {
        background-image: linear-gradient($terms, $terms-light);
    }
    .is-anchor-link {
        margin-right: 0.5rem;
    }

    .has-padding-left {
        padding-left: 1rem;
    }

    //Adds the new paragraph identation.
    .has-text-identation {
        text-indent: 1.5rem;
    }

    .has-left-margin {
        margin-left: 1.5rem;
    }
    .has-left-margin2 {
        margin-left: 3.0rem;
    }
</style>